import { TemplateLink } from "./TemplateLink"

export default function StarfishContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        Starfish is generally credited to{" "}
        <a
          href="https://www.patkua.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Patrick Kua
        </a>
        , who was writing about agile facilitation in the mid-to-late 2000s.
        The five arms (Keep Doing, More Of, Less Of, Stop Doing, Start Doing)
        split the binary Continue and Stop into a gradient. It turns out most
        team practices aren't "keep exactly as-is" or "abolish forever";
        they're somewhere on a dial.
      </p>

      <h2>When to use this format</h2>
      <p>
        Use it when the team has enough shared history to have opinions with
        nuance. Starfish gives people a way to say "I want more pairing"
        without also being forced to say "our current pairing is broken."
        The extra columns let people register a preference without picking
        a fight.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Five columns is a lot. Skip Starfish for retros under 45 minutes,
        for teams larger than eight, or for anyone new to facilitation. The
        format demands more of the facilitator than the participants, and
        running out of time at column three is worse than running the wrong
        format. Reach for{" "}
        <TemplateLink to="start-stop-continue">Start / Stop / Continue</TemplateLink>{" "}
        if you're time-boxed.
      </p>

      <h2>How to run it</h2>
      <p>
        Fifteen minutes silent writing (people need extra time to figure out
        which arm each item belongs on). Group and vote. Discuss <em>More
        Of</em> and <em>Less Of</em> first; that's where the format earns
        its extra columns. Keep, Stop, and Start read like a normal Start
        Stop Continue at the end. Retroboard's session timer helps keep
        each column's discussion honest so nothing eats the whole meeting.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        People argue about column assignment. "Should this be Less Of or
        Stop Doing?" Waste no more than 30 seconds on the debate; the
        answer usually doesn't matter, and the discussion is a
        procrastination on the actual conversation. Move on.
      </p>
    </>
  )
}
